﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { htmlPromise } from '../../../../Resources/Scripts/_Shared/fetch';

function nearbyFacilities(context) {
  const loader = context.querySelector('.facilitypage__loader');
  const ctaButton = context.querySelector('button.facilitypage__nearby-facilities__cta');
  const currentLanguage = document.querySelector('html').getAttribute('lang');

  const facilityPosition = {
    name: context.dataset.name, 
    longitude: context.dataset.lng, 
    latitude: context.dataset.lat,
    skipuid: context.dataset.skipuid,
  }

  function addPromotionIcon(item) {
    const img = document.createElement('img');
    const altTexts = {
        sv: 'kampanjikon',
        fi: 'promo-kuvake',
        no: 'kampanjeikon',
        en: 'promotion icon' 
    };
    img.src = `/publicResources/icons/promo/${currentLanguage}/Promotion2_${currentLanguage}.svg`;
    img.alt = altTexts[currentLanguage] || altTexts.en;
    item.appendChild(img);
    item.classList.add('with-promotion');
  }

  function addAvailabilityIcon(item, hasLowAvailability) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('left--availablespot');
    wrapper.setAttribute('data-low', hasLowAvailability);
    const div = document.createElement('div');
    div.innerText = hasLowAvailability ? context.dataset.lowAvailabilityText : context.dataset.availabilityText;
    const address = item.querySelector('.left span');
    if (address) wrapper.appendChild(address);
    wrapper.appendChild(div);
    const leftWrapper = item.querySelector('.left');
    leftWrapper.appendChild(wrapper);
  }

  async function checkDetails(uid) {
    const allProducts = await htmlPromise('/booking/getFacilitySummary', { bookingController: '/booking/', fId: uid, lang: currentLanguage, includeNotBookableOnline: true }).catch((err) => err);
    if (allProducts && allProducts.status === 200) {
      const allProductsBody = JSON.parse(allProducts.body);
      const allProductsBodyData = allProductsBody.Data;
      if (allProductsBodyData.Places.length > 0) {
        const listOfProducts = allProductsBodyData.Places.map(zone => zone.Item2).flat();
        const hasPromotion = listOfProducts.some(product => Array.isArray(product.Promotions) && product.Promotions.length > 0);
        const isBookableOnline = listOfProducts.some(product => !product.OnlineBookingNotAllowed);
        const hasAvailability = listOfProducts.some(product => !product.OnlineBookingNotAllowed && product.Availability && product.Availability > 0);
        const hasLowAvailability = hasAvailability && !listOfProducts.some(product => !product.OnlineBookingNotAllowed && product.Availability && product.Availability > 4);
        return { hasPromotion, hasAvailability, hasLowAvailability, isBookableOnline };
      }
    }
    return false;
  }

  async function checkFacilities(facilityList, listItems) {
    if (listItems.length === 0) return;
    const visibleItems = +facilityList.dataset.visible;
    const startItem = visibleItems - (visibleItems % 5 || 5);
    for (let i = startItem; i < visibleItems; i++) {
      const item = listItems[i];
      const uid = item.dataset.facilityUid;
      if (!uid) return;
      const facilityDetails = await checkDetails(uid);
      if (facilityDetails.hasPromotion) addPromotionIcon(item);
      if (!context.dataset.hideAvailability && facilityDetails.isBookableOnline && facilityDetails.hasAvailability && context.dataset.availabilityText) addAvailabilityIcon(item, facilityDetails.hasLowAvailability);
    }
  }

  async function init() {
    const getNearbyFacilities = await htmlPromise(document.location.pathname + '/getnearbyfacilities', facilityPosition).catch((err) => err);
    if (getNearbyFacilities.status === 200) {
      let placeholder = document.createElement('span');
      placeholder.innerHTML = getNearbyFacilities.body;
      context.insertBefore(placeholder, context.childNodes[0]);
      context.removeAttribute('aria-busy');
      loader.remove();
      const facilityList = context.querySelector('ul');
      const listItems = facilityList.querySelectorAll('li[data-facility-uid]');
      if (listItems.length === 0 || listItems.length === +facilityList.dataset.visible) ctaButton.remove()
      else {
        ctaButton.addEventListener('click', () => {
          const currentlyVisibleItems = +facilityList.dataset.visible;
          facilityList.dataset.visible = (currentlyVisibleItems + 5) < listItems.length ? currentlyVisibleItems + 5 : listItems.length;
          listItems.forEach((item, index) => {
            if (index < +facilityList.dataset.visible) item.classList.remove('hidden');
          });
          if (listItems.length === +facilityList.dataset.visible) ctaButton.remove();
          checkFacilities(facilityList, listItems);
        })
        ctaButton.removeAttribute('disabled');
      }
      checkFacilities(facilityList, listItems);
		} else {
      context.remove();
    }
  };

  return {
    init
  };
}

controller.add('nearby-facilities', nearbyFacilities);
